import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { ShoppingCart, Heart } from 'lucide-react';

const MerchandiseCard = ({ item, onAddToCart }) => {
  return (
    <Card className="group overflow-hidden border-none shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 bg-white">
      <div className="relative overflow-hidden">
        <div className="aspect-square overflow-hidden bg-gray-100">
          <img 
            src={item.image} 
            alt={item.name}
            className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
          />
        </div>
        {item.badge && (
          <div className="absolute top-4 right-4 bg-blue-600 text-white px-3 py-1 rounded-full text-xs font-semibold">
            {item.badge}
          </div>
        )}
        <button className="absolute top-4 left-4 w-10 h-10 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 hover:bg-white hover:scale-110">
          <Heart className="w-5 h-5 text-gray-700 hover:text-red-500 transition-colors" />
        </button>
      </div>
      
      <CardHeader className="pb-3">
        <CardTitle className="text-xl font-bold text-gray-900">{item.name}</CardTitle>
        <CardDescription className="text-sm text-gray-600 mt-2">
          {item.description}
        </CardDescription>
      </CardHeader>
      
      <CardContent>
        <div className="space-y-4">
          {item.sizes && (
            <div className="text-sm text-gray-600">
              <span className="font-medium text-gray-800">Sizes:</span> {item.sizes}
            </div>
          )}
          
          <div className="flex items-center justify-between">
            <div className="flex flex-col">
              <span className="text-2xl font-bold text-blue-600">€{item.price}</span>
              <span className="text-xs text-gray-500">Donation</span>
            </div>
            
            <Button 
              onClick={() => onAddToCart(item)}
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-5 font-semibold transition-all duration-300 hover:scale-105 hover:shadow-lg"
            >
              <ShoppingCart className="mr-2 h-5 w-5" />
              Buy Now
            </Button>
          </div>
          
          {item.shippingNote && (
            <p className="text-xs text-gray-500 italic mt-2 border-t pt-2">
              {item.shippingNote}
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default MerchandiseCard;
